import { Grid, styled } from "@mui/material";

const GridContainer = styled(Grid)(() => ({
    padding: "1rem"
}));

export default GridContainer